import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Templates = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="templates-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.63333 3.25C4.13181 3.25 3.6521 3.45096 3.2994 3.80663C2.94691 4.16208 2.75 4.64286 2.75 5.14286V18.2857C2.75 18.9373 3.00661 19.5634 3.46537 20.026C3.92435 20.4888 4.54819 20.75 5.2 20.75H18.8C19.4518 20.75 20.0757 20.4888 20.5346 20.026C20.9934 19.5634 21.25 18.9373 21.25 18.2857V7.42857C21.25 7.01436 20.9142 6.67857 20.5 6.67857C20.0858 6.67857 19.75 7.01436 19.75 7.42857V18.2857C19.75 18.5435 19.6484 18.7894 19.4695 18.9698C19.2909 19.1499 19.0499 19.25 18.8 19.25C18.5501 19.25 18.3091 19.1499 18.1305 18.9698C17.9516 18.7894 17.85 18.5435 17.85 18.2857V5.14286C17.85 4.64285 17.6531 4.16208 17.3006 3.80663C16.9479 3.45096 16.4682 3.25 15.9667 3.25H4.63333ZM16.35 18.2857C16.35 18.6201 16.4176 18.9477 16.5454 19.25H5.2C4.95008 19.25 4.70911 19.1499 4.53046 18.9698C4.3516 18.7894 4.25 18.5435 4.25 18.2857V5.14286C4.25 5.03665 4.2919 4.93604 4.36449 4.86284C4.43687 4.78985 4.5337 4.75 4.63333 4.75H15.9667C16.0663 4.75 16.1631 4.78985 16.2355 4.86284C16.3081 4.93604 16.35 5.03665 16.35 5.14286V18.2857ZM6.3125 13.375C5.89829 13.375 5.5625 13.7108 5.5625 14.125C5.5625 14.5392 5.89829 14.875 6.3125 14.875H14.1875C14.6017 14.875 14.9375 14.5392 14.9375 14.125C14.9375 13.7108 14.6017 13.375 14.1875 13.375H6.3125ZM5.5625 16.375C5.5625 15.9608 5.89829 15.625 6.3125 15.625H10.8125C11.2267 15.625 11.5625 15.9608 11.5625 16.375C11.5625 16.7892 11.2267 17.125 10.8125 17.125H6.3125C5.89829 17.125 5.5625 16.7892 5.5625 16.375ZM6.3125 6.0625C5.89829 6.0625 5.5625 6.39829 5.5625 6.8125V11.3125C5.5625 11.7267 5.89829 12.0625 6.3125 12.0625H14.1875C14.6017 12.0625 14.9375 11.7267 14.9375 11.3125V6.8125C14.9375 6.39829 14.6017 6.0625 14.1875 6.0625H6.3125ZM7.0625 10.5625V7.5625H13.4375V10.5625H7.0625Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
